import ReactPaginate from "react-paginate";


/**
 * Pagination (page numbers) JSX for search results. Each page number is linked
 * to viewing that page.
 *
 * @param props.searchData (response from backend)
 * @param props.onNewPageSelect (callback function that handles page change)
 * @param props.pageNum Page number (1-indexed)
 * @return JSX for displaying in the page
 */
export function SearchResultsPagination(props) {

    const {searchData, onNewPageSelect, pageNum} = props;

    if (searchData.numPages === 1) {
        return <div />;
    }

    const onPageChange = async (event) => {
        await onNewPageSelect({ pageNum: event.selected + 1});
    };

    return (
        <ReactPaginate
          className="searchResultsPaginator"
          breakLabel="..."
          nextLabel="&#xbb;"
          onPageChange={onPageChange}
          pageRangeDisplayed={3}
          pageCount={searchData.numPages}
          previousLabel="&#xab;"
          forcePage={(pageNum || 1) - 1}
          renderOnZeroPageCount={null}
        />
    );
}

